import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs/Rx";
import { GeocodingService } from "../geocoding.service";
import { MapService } from "../map.service";
import { Location } from "../location";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import * as $ from "jquery";
import * as A from "jquery-ui";
import * as L from "leaflet-geotiff";
import "rxjs/add/operator/catch";
import "hammerjs";
import Sortable from "sortablejs";
import { RouterModule, Routes, ActivatedRoute } from "@angular/router";

var jsonToArray = [];
var opacityArray = [];
var imageArray = [];
var zIndexArray = [];
var arrayStrCoords = []; //koku punktu koordinatas

@Component({
  selector: "app-map",
  templateUrl: "./map.component.html",
  styleUrls: ["./map.component.scss"]
})
export class MapComponent implements OnInit {
  private address: string;
  private overlays = {};
  private izskats;

  constructor(
    private mapService: MapService,
    private geocoder: GeocodingService
  ) {
    this.address = "";
  }

  ngOnInit() {
    // default map location
    // Izmanto WGS 84!!
    const location = new Location();
    location.address = "Ventspils, Latvia";
    location.latlng = L.latLng(57.3, 21.4);
    //layer boundaries definitions
    var southWest = L.latLng(57.3, 21.4), //TODO check for correct bounding box, based off the actual coordinates
      northEast = L.latLng(57.54, 21.84),
      layerbounds = L.latLngBounds(southWest, northEast);
    var baseMaps = this.mapService.baseMaps;
    const map = L.map("map", {
      zoomControl: false,
      center: location.latlng,
      maxBounds: layerbounds,
      zoom: 12,
      zoomSnap: 1,
      minZoom: 8,
      maxZoom: 18,
      layers: [baseMaps.OpenStreetMap] //pilnais saraksts ar slaniem atrodams map.service.ts
    });

    //map.addLayer(baseMaps);
    L.control.zoom({ position: "topleft" }).addTo(map);

    // Mobilai versijai noņemt + un - zoom
    if (L.Browser.mobile) {
      $(".leaflet-control-zoom").css("visibility", "hidden");
    }
    this.izskats = L.control.layers(baseMaps, this.overlays);//.addTo(map); //vecais layer control, tiek paslepts
    L.control.scale().addTo(map); //mērogs
    this.address = location.address;
    // $.ajax({
      // dataType: "json", //you shouldn't need to declare geojson
      // url: "http://talizpete.venta.lv:8090/imagelist",
      // async: false, //sis nav labi, beigas vajadzetu tikt no sis rindinas valaa (ok maybe nee)
      // success: function(data) {
        // jsonToArray = Object.keys(data).map(function(_) {
          // return data[_];
        // });
      // },
      // error: function(e) {
        // console.log(e);
      // }
    // });
    // console.log(jsonToArray);

    //Pagaidu variants, izmainīt. Noņemt nevajadzīgos elementus.
    jsonToArray = [
    //  "1,1,1,1,Ventspils RGB,l",
      "1,1,1,1,Ēnu karte (rudens 21.09),l",
      "1,1,1,1,Ēnu karte (ziema 21.12),l",
      "1,1,1,1,Ēnu karte (vasara 21.06),l",
      "1,1,1,1,Koku vainagu nosegums,l"
    ];
    // Sis izveido vektoru ar zindexiem, kas nepieciesams slanu secibas mainisanai
    for (var i = 0; i < jsonToArray.length; i++) {
      zIndexArray.push((i + 2).toString());
    }
    jsonToArray = this.layerSetup(jsonToArray, zIndexArray);

    this.mapSetup(map, this.izskats, jsonToArray, baseMaps);

    // Sis atlauj neierobezotu slanu skaitu
    var opacityNames = [];
    for (var i = 0; i < imageArray.length; i++) {
      opacityNames.push("opacity" + i);
      imageArray[i].setOpacity(0.0); //default opacity kā 0.0
    }
    // Jaiet foreach cikla, ja izmanto parasto for ciklu, tad paliek pie pedeja indeksa
    opacityNames.forEach(opacityFunction);

    //Si funkcija pareizi sazime caurspidigumu
    function opacityFunction(item, index) {
      document.getElementById(item).oninput = function() {
        opacityArray[index] = (<HTMLInputElement>(
          document.getElementById(item)
        )).value;
        imageArray[index].setOpacity(opacityArray[index]);
      };
    }
    //Paslept vai paradit layer menu
    $(document).ready(function() {
      $("#show-button").click(function() {
        $("#hide-button").show();
        $("#show-button").hide();
        $("#sortables").show();
      });
      $("#hide-button").click(function() {
        $("#show-button").show();
        $("#hide-button").hide();
        $("#sortables").hide();
      });
    });
  }

  //Draw custom layer navigation box with opacity slider for each layer
  layerSetup = function(jArray, zArray) {
    var el = document.getElementById("items");

    var kokiEl = document.getElementById("koki") as HTMLInputElement; // koku checkbox
    kokiEl.onclick = function() {
      if (kokiEl.checked) {
        console.log("checked");
      } else {
        console.log("unchecked");
      }
    };
    var layerCSS = document.getElementsByClassName(
      "leaflet-image-layer leaflet-zoom-animated"
    ); //sadi iegust visiem slaniem css, kuriem pec tam maina z-index
    var backgroundCSS = document.getElementsByClassName(
      "leaflet-pane leaflet-tile-pane"
    );
    var finalArray = []; //sis ir vajadzigs, jo zindex ir piesaistits parastajam indexam un jauzglaba sakariba starp abiem
    var sortable = Sortable.create(el, {
      onEnd: function(evt) {
        if (evt.oldIndex == evt.newIndex) {
          zArray = zArray.reverse();
        } else if (evt.oldIndex < evt.newIndex) {
          //uz leju
          jArray.splice(evt.newIndex + 1, 0, jArray[evt.oldIndex]); //nosaukumus karto pareiza seciba
          jArray.splice(evt.oldIndex, 1);
          zArray = zArray.reverse(); //apgriezam otradi, jo layer viewer attelo slanus otradi
          zArray.splice(evt.newIndex + 1, 0, zArray[evt.oldIndex]); //zindexus ari
          zArray.splice(evt.oldIndex, 1);
        } else {
          //uz augsu
          jArray.splice(evt.newIndex, 0, jArray[evt.oldIndex]);
          jArray.splice(evt.oldIndex + 1, 1);
          zArray = zArray.reverse();
          zArray.splice(evt.newIndex, 0, zArray[evt.oldIndex]);
          zArray.splice(evt.oldIndex + 1, 1);
        }
        zArray = zArray.reverse(); //pec tam atgriezam atpakal
        for (var j = 0; j < layerCSS.length; j++) {
          finalArray[j] = zArray.indexOf((j + 2).toString()) + 2;
          (layerCSS[j] as HTMLElement).style.zIndex = finalArray[j];
        }
      },
      animation: 150,
      handle: ".myHandle"
    });
    for (var k in jArray) {
      if (jArray.hasOwnProperty(k)) {
        var splitk = jArray[k].split(",");

        el.innerHTML =
          el.innerHTML +
          "<tr><td><div class='myHandle' style='cursor: move;'>" +
          splitk[4] +
          "</div></td><td><input id='opacity" +
          k +
          "' type='range' value='opacity' max='1.0' min='0' step='0.01'/></td></tr>";
        // @ts-ignore
        document.getElementById("opacity" + k).defaultValue = 0.0; //vins netic, ka sii linija actually strada, tapec jauzliek ignore error
      }
    }
    return jArray;
  };

  mapSetup = function(map, izskats, jArray, basem) {
    var sW, nE, imBounds, reverseK;
    imBounds = L.latLngBounds(sW, nE);
    for (var k in jArray) {
      reverseK = jArray.length - Number(k) - 1; //nepieciesams ieviest reverseK, lai slani tiktu pievienoti apgreizta seciba
      var userOpacity = opacityArray[reverseK];
      if (jArray.hasOwnProperty(reverseK)) {
        var splitk = jArray[reverseK].split(",");
        sW = L.latLng(splitk[0].toString(), splitk[1].toString());
        nE = L.latLng(splitk[2].toString(), splitk[3].toString());
        imBounds = L.latLngBounds(sW, nE);

        // Pagaidu variants. Pārtaisit uz arrays vai kaut ko citu
        if (splitk[4] == "Ventspils RGB") {
          var image = basem.VentspilsCustom.addTo(map);
        } //Rinda, kuru pievienoju 20.01.2022, atlauj darboties ar tiles
        if (splitk[4] == "Ēnu karte (rudens 21.09)") {
          var image = basem.enu_karte_rudens.addTo(map);
        }
        if (splitk[4] == "Ēnu karte (ziema 21.12)") {
          var image = basem.enu_karte_ziema.addTo(map);
        }
        if (splitk[4] == "Ēnu karte (vasara 21.06)") {
          var image = basem.enu_karte_vasara.addTo(map);
        }
        if (splitk[4] == "Koku vainagu nosegums") {
          var image = basem.koku_vainagu_nosegums.addTo(map);
        }

        //var image = L.imageOverlay(									// Veca versija, kas darbojas bez tiles
        //  "http://talizpete.venta.lv:8090/sub/" + jArray[reverseK],
        //  imBounds,
        //  {
        //    crossOrigin: true,
        //    show: false,
        //    opacity: userOpacity
        //  }
        //).addTo(map);

        imageArray[reverseK] = image;
        izskats.addOverlay(image, splitk[4]);
      }
    }

    var kokiEl = document.getElementById("koki") as HTMLInputElement; // koku checkbox

    // FUNKCIJA
    function readTextFile(file) {
      //funkcija, kas saliek visas koordinatas no teksta faila masiivaa
      var rawFile = new XMLHttpRequest();
      rawFile.open("GET", file, false);
      rawFile.onreadystatechange = function() {
        if (rawFile.readyState === 4) {
          if (rawFile.status === 200 || rawFile.status == 0) {
            var allText = rawFile.responseText;
            arrayStrCoords = allText.split("\n");
            console.log(arrayStrCoords.length);
          }
        }
      };
      rawFile.send(null);
    }
    //

    var allText = readTextFile("../assets/coords.txt"); //izsaucam augstak esoso funkciju, lai nolasitu punktu koordinasu failu
    var myRenderer = L.canvas({ padding: 0.5 });
    var layerGroup = L.layerGroup();

    kokiEl.onclick = function() {
      //kods palaidisies tikai, ja ieklikskinasim checkbox
      if (kokiEl.checked) {
        //ja iekeksets attelot kokus
        for (var i = 0; i < arrayStrCoords.length; i += 1) {
          //ejam cauri visiem punktiem masiva un individuali pievienojam slanu grupai
          var arrayStrCoords1 = arrayStrCoords[i].split(","); //
          var parsedLng = parseFloat(arrayStrCoords1[0].substring(2)); //nolasam lng un lat individuali. Panemam tikai pasu skaitli bez visam kvadratiekavam
          var parsedLat = parseFloat(arrayStrCoords1[1]);

          if (arrayStrCoords1[0].length > 1)
            //parbaudam vai koordinatu rindina nav tuksa un reali satur koordinatas
            layerGroup.addLayer(
              L.circleMarker([parsedLat, parsedLng], {
                //un samainam ar vietam, jo formatejums ir otrads
                radius: 1,
                renderer: myRenderer
              })
            ); //.bindPopup('marker ' + i);
        }
        layerGroup.addTo(map);
      } else {
        map.removeLayer(layerGroup); // ja izkeksee, tad nonem slani no kartes
      }
    };
  };
}
